let simpleStore;

simpleStore = simpleStore || {};

export default simpleStore;